import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * A square stop icon component used for the interrupt button
 * @component
 * @param {SvgIconProps} props - Material-UI SvgIcon props
 * @returns {JSX.Element} A square icon representing the stop action
 */
export const StopIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <rect x="5" y="5" width="14" height="14" />
    </SvgIcon>
  );
};
